export default `
<a href="#" class="toggle-link clickable" role="button" title="{{$ctrl.active ? 'Locked' : 'Unlocked'}}">
  <i class="material-icons" ng-class="{'active': $ctrl.active}">{{$ctrl.active ? 'lock' : 'lock_open'}}</i>
</a>
`;
